import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@material-ui/core";
import LoadingIndicator from "./LoadingIndicator";

const ViewPaymentLog = ({
  paymentIdForViewPaymentLog,
  openPopup,
  setOpenPopup,
  paymentLogApiUrl,
  createNetInspectionApiClient,
}) => {
  const [loading, setLoading] = useState(false);
  const adminPaymentLogDataBaseUrl = paymentLogApiUrl();

  const [paymentLogData, setPaymentLogData] = useState([]);
  // console.log("paymentid", paymentIdForViewPaymentLog);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let getDataUrl = `${adminPaymentLogDataBaseUrl}${paymentIdForViewPaymentLog}`;
        // console.log("dataurl", getDataUrl);

        let fetchedPaymentLogData = [];

        // fetch first page data

        let firstCallResponse = await createNetInspectionApiClient().get(
          `${getDataUrl}`
        );

        // process records for null date values
        const processedData = firstCallResponse.data.items.map((item) => {
          if (item.deposit_date === "0001-01-01T00:00:00") {
            return { ...item, deposit_date: "" };
          }
          return { ...item };
        });
        // console.log(processedData);
        fetchedPaymentLogData.push(...processedData);
        // once we have all data retrieved
        // set the local state data
        setPaymentLogData(fetchedPaymentLogData);
        // console.log(fetchedInspectionData);
        setLoading(false);
      } catch (err) {
      } finally {
      }
    };

    fetchData();
  }, [ViewPaymentLog]);

  const convertIsoDateStringToReglarDateString = (dateString) => {
    if (dateString === "") return;
    const bits = dateString.substring(0, 10).split("-");

    // biits [0] = year bits[1] = month bits[2] = day
    const formattedDate = `${bits[1]}/${bits[2]}/${bits[0]}`;
    return formattedDate;
  };

  // console.log("retrieved data: ", paymentLogData);
  let content;

  if (loading) {
    content = <LoadingIndicator />;
  } else {
    content = (
      <>
        <TableContainer component={Paper}>
          <Table
            style={{
              border: "1px solid black",
              borderCollapse: "collapse",
              width: "800px",
            }}
          >
            <TableHead style={{ backgroundColor: "InfoBackground" }}>
              <TableRow>
                <TableCell>Payment Id</TableCell>
                <TableCell>Payment Type</TableCell>
                <TableCell>Check Nbr</TableCell>
                <TableCell>Payment Date</TableCell>
                <TableCell>Deposit Date</TableCell>
                <TableCell>Modified Date</TableCell>
                <TableCell>Modified By</TableCell>
              </TableRow>
            </TableHead>
            {paymentLogData.length > 0 && (
              <TableBody>
                {paymentLogData.map((row) => {
                  return (
                    <TableRow key={row.id}>
                      <TableCell>{row.payment_id}</TableCell>
                      <TableCell>{row.payment_type}</TableCell>
                      <TableCell>{row.check_number}</TableCell>
                      <TableCell>
                        {convertIsoDateStringToReglarDateString(
                          row.payment_date
                        )}
                      </TableCell>
                      <TableCell>
                        {convertIsoDateStringToReglarDateString(
                          row.deposit_date
                        )}
                      </TableCell>
                      <TableCell>
                        {convertIsoDateStringToReglarDateString(
                          row.modified_date
                        )}
                      </TableCell>
                      <TableCell>{row.modified_by_user}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}
          </Table>
        </TableContainer>
        <div
          style={{
            width: "800px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            style={{
              width: "80px",
              height: "20px",
              fontSize: "0.8rem",
              padding: "8px",
              margin: "10px",
            }}
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            Close
          </Button>
        </div>
      </>
    );
  }

  return <>{content}</>;
};

export default ViewPaymentLog;
